import { render } from "./validation-error-modal.vue?vue&type=template&id=5d10e59a&scoped=true"
import script from "./validation-error-modal.vue?vue&type=script&lang=js"
export * from "./validation-error-modal.vue?vue&type=script&lang=js"

import "./validation-error-modal.vue?vue&type=style&index=0&id=5d10e59a&scoped=true&lang=css"

import exportComponent from "/var/www/birchplace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d10e59a"]])

export default __exports__